import { styled } from '@mui/system';
import { Box, Typography, Divider, Button } from '@mui/material';

export const ShiftDetailsPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  padding: `0 ${theme.spacing(2.5)} ${theme.spacing(2.5)}`,
  boxSizing: 'border-box',
  overflow: 'auto',
  gap: theme.spacing(2),
}));

export const ShiftDetailsCard = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.secondary,
  borderRadius: theme.spacing(1.25),
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const ShiftTimeText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const ShiftSwapButton = styled(Button)(({ theme }) => ({
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.secondary,
  textTransform: 'none',
  width: '100%',
  marginTop: theme.spacing(2),
}));

export const ShiftDetailsDivider = styled(Divider)(({ theme }) => ({
  width: '100%',
  margin: `${theme.spacing(1)} 0`,
}));

export const ShiftSeparatorDivider = styled(Divider)(({ theme }) => ({
  width: '100%',
  margin: `${theme.spacing(2)} 0`,
}));

export const DetailLabelGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));

export const BreakItemContainer = styled(Box)(({ theme }) => ({
  width: '100%',
}));

export const ShiftDetailRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
}));

export const SecondaryText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
